'use client'

import { ROUTES } from '@/core/constants/routes'
import { capitalizeFirstLetter } from '@/core/lib/utils/capitalize-first-letter'
import { Category } from '@/features/categories/model/category.model'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { use } from 'react'

export const Footer = ({ categories }: { categories: Promise<Category[]> }) => {
  const categoriesList = use(categories).map(cat => ({
    ...cat,
    href: `${ROUTES.search}?${ROUTES.searchParam({ name: 'categories', value: cat.slug })}`,
  }))
  const t = useTranslations()
  return (
    <footer className='border-t border-gray-200 bg-white pt-10 pb-7 text-gray-700'>
      <div className='container mx-auto grid w-full grid-cols-1 gap-20 px-4 sm:px-10 md:grid-cols-[1fr_2fr] md:px-9'>
        <div className='flex flex-col items-start'>
          <div className='mb-4 flex items-center gap-2'>
            <Image
              src='/images/logo.png'
              alt='Future Way logo'
              width={140}
              height={90}
            />
          </div>
          <p className='text-mountain-bluebird max-w-sm text-base leading-6'>
            {t('footer.description')}
          </p>
        </div>

        <div className='grid grid-cols-2 gap-2 sm:grid-cols-3'>
          <div>
            <h3 className='text-mountain-bluebird mb-4 text-lg font-semibold'>
              {t('footer.Categories')}
            </h3>
            <ul className='space-y-2 text-base'>
              {categoriesList.slice(0, 8).map(cat => (
                <li
                  key={cat.id}
                  className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']"
                >
                  <Link href={cat.href}>{capitalizeFirstLetter(cat.name)}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More */}
          <div>
            <h3 className='text-mountain-bluebird mb-4 text-lg font-semibold'>
              {t('footer.more')}
            </h3>
            <ul className='space-y-2 text-base'>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                <Link href='/about-us'>{t('footer.about')}</Link>
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                {t('footer.contact')}
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                <Link href='/privacy-policy'>{t('footer.privacy')}</Link>
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                <Link href='/terms'>{t('footer.terms')}</Link>
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                <Link href='/blog'>{t('footer.blog')}</Link>
              </li>
            </ul>
          </div>

          {/* Follow us */}
          <div className='col-span-2 sm:col-span-1'>
            <h3 className='text-mountain-bluebird mb-4 text-lg font-semibold'>
              {t('footer.Follow us')}
            </h3>
            <ul className='space-y-2 text-sm'>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                Facebook
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                Instagram
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                Telegram
              </li>
              <li className="hover:text-creamed-cron flex cursor-pointer items-center gap-1 hover:before:content-['–']">
                Whatsapp
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* </div> */}
      <div className='mt-10 pt-4 text-center text-xs text-[#B0AAAB]'>
        All rights reserved. 2025{' '}
        <Link href='/' className='text-creamed-cron font-semibold'>
          Future way
        </Link>
      </div>
    </footer>
  )
}

export default Footer
